module.exports = __webpack_public_path__ + "media/banjo-and-kazooie.ff8003ef.wav";